var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.539,
    height: 198.539,
    viewBox: "0 0 198.539 198.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19337",
    "data-name": "Group 19337",
    transform: "translate(30.724 30.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2833",
    "data-name": "Ellipse 2833",
    transform: "translate(32.703 32.513)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.842,
    cy: 35.842,
    r: 35.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.842,
    cy: 35.842,
    r: 35.342,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    transform: "translate(-30.724 -30.914)",
    fill: "#fff",
    stroke: "#51cb20",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.269,
    cy: 99.269,
    r: 99.269,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.269,
    cy: 99.269,
    r: 98.769,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2892",
    "data-name": "Ellipse 2892",
    transform: "translate(-11.343 -11.534)",
    fill: "#fff",
    stroke: "#51cb20",
    strokeWidth: 1,
    opacity: 0.245
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79.889,
    cy: 79.889,
    r: 79.889,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.889,
    cy: 79.889,
    r: 79.389,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    transform: "translate(6.275 6.085)",
    fill: "#fff",
    stroke: "#51cb20",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.27,
    cy: 62.27,
    r: 62.27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.27,
    cy: 62.27,
    r: 61.77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M90.167,45.365a44.8,44.8,0,1,1-44.8-44.8A44.8,44.8,0,0,1,90.167,45.365ZM40.183,69.087l33.24-33.241a2.89,2.89,0,0,0,0-4.088l-4.088-4.088a2.89,2.89,0,0,0-4.088,0L38.139,54.78,25.482,42.124a2.891,2.891,0,0,0-4.088,0l-4.088,4.088a2.891,2.891,0,0,0,0,4.088L36.095,69.087A2.891,2.891,0,0,0,40.183,69.087Z",
    transform: "translate(22.844 22.99)",
    fill: "#51cb20"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircles);
export default __webpack_public_path__ + "static/media/tick_circles.49e513b6343090e28a717fb609726aaa.svg";
export { ForwardRef as ReactComponent };